<page-title title="Dados Bancários"></page-title>

<div class="bank-details-container">
  <page-alert [message]="messageSuccess" *ngIf="showSuccessMessage" alertClass="alert-success"></page-alert>
  <page-alert [message]="messageError" *ngIf="showErrorMessage" alertClass="alert-danger"></page-alert>

  <mat-card class="recipient-status-card">
    <div class="recipient-status-header">
      <div>
        <span class="recipient-status-eyebrow">Status Pagar.me</span>
        <h3>Cadastro como recebedor</h3>
      </div>
      <span class="recipient-status-badge" [ngClass]="recipientStatus.code">{{ recipientStatus.label }}</span>
    </div>

    <p class="recipient-status-description">{{ recipientStatus.description }}</p>

    <div class="recipient-status-grid">
      <div class="recipient-status-item">
        <span>Recebedor</span>
        <strong>{{ recipientStatus.recipientLabel }}</strong>
      </div>
      <div class="recipient-status-item">
        <span>Validacao</span>
        <strong>{{ recipientStatus.kycLabel }}</strong>
      </div>
      <div class="recipient-status-item">
        <span>Conta bancaria</span>
        <strong>{{ recipientStatus.bankAccountLabel }}</strong>
      </div>
      <div class="recipient-status-item">
        <span>Cadastro Pagar.me</span>
        <strong>{{ recipientStatus.onboardingLabel }}</strong>
      </div>
    </div>

    <div class="recipient-status-next-step">{{ recipientStatus.nextStep }}</div>
  </mat-card>

  <mat-tab-group>
    <mat-tab label="Dados Bancários">
      <mat-card>
        <form [formGroup]="bankDetailsForm">
          <div class="row">
            <div class="col-xs-12">
              <h3>Dados Bancários</h3>
            </div>

            <div class="col-xs-12 col-sm-6">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Nome do Titular</mat-label>
                <input matInput formControlName="holder_name" placeholder="Digite o nome completo do titular" />
                <mat-error *ngIf="bankDetailsForm.get('holder_name')?.hasError('required')">O nome do titular é obrigatório.</mat-error>
                <mat-error *ngIf="bankDetailsForm.get('holder_name')?.hasError('minlength')">Informe pelo menos 3 caracteres.</mat-error>
                <mat-error *ngIf="bankDetailsForm.get('holder_name')?.hasError('maxlength')"
                  >Nome do titular deve ter no maximo 30 caracteres e deve ser o nome no cartao relacionado a esta conta.</mat-error
                >
                <mat-error *ngIf="bankDetailsForm.get('holder_name')?.hasError('pattern')">Informe um nome valido.</mat-error>
              </mat-form-field>
            </div>

            <div class="col-xs-12 col-sm-6">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Banco</mat-label>
                <input
                  type="text"
                  matInput
                  formControlName="bank_search"
                  [matAutocomplete]="bankAuto"
                  placeholder="Digite o nome ou codigo do banco"
                  (input)="onBankInputChanged()"
                  (blur)="trySelectTypedBank()"
                />
                <mat-autocomplete #bankAuto="matAutocomplete" [displayWith]="displayBank" (optionSelected)="onBankSelected($event)">
                  <mat-option *ngFor="let bank of filteredBanks$ | async" [value]="bank">
                    {{ formatBankCode(bank.code) }} - {{ bank.fullName || bank.name }}
                  </mat-option>
                </mat-autocomplete>
                <mat-error
                  *ngIf="
                    bankSearch?.hasError('required') ||
                    bankDetailsForm.get('bank')?.hasError('required') ||
                    bankDetailsForm.get('bank_number')?.hasError('required')
                  "
                >
                  Selecione um banco valido.
                </mat-error>
              </mat-form-field>
              <input type="hidden" formControlName="bank" />
              <input type="hidden" formControlName="bank_number" />
            </div>

            <div class="col-xs-12 col-sm-6">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Tipo de Pessoa</mat-label>
                <mat-select formControlName="holder_type">
                  <mat-option value="individual">Pessoa Física</mat-option>
                  <mat-option value="company">Pessoa Jurídica</mat-option>
                </mat-select>
                <mat-error *ngIf="bankDetailsForm.get('holder_type')?.hasError('required')">O tipo de pessoa é obrigatório.</mat-error>
              </mat-form-field>
            </div>

            <div class="col-xs-12 col-sm-6">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Documento do Titular</mat-label>
                <input matInput formControlName="holder_document" [mask]="documentMask" [placeholder]="documentPlaceholder" />
                <mat-error *ngIf="documentControl?.hasError('required')">O documento é obrigatório.</mat-error>
                <mat-error *ngIf="documentControl?.hasError('cpfInvalid')">CPF inválido.</mat-error>
                <mat-error *ngIf="documentControl?.hasError('cnpjInvalid')">CNPJ inválido.</mat-error>
              </mat-form-field>
            </div>

            <ng-container *ngIf="isCompanySelected">
              <div class="col-xs-12"><h3>Dados da Pessoa Juridica</h3></div>
              <div class="col-xs-12 col-sm-6">
                <mat-form-field appearance="outline" class="form-field">
                  <mat-label>Nome fantasia</mat-label>
                  <input matInput formControlName="company_name" />
                  <mat-error *ngIf="bankDetailsForm.get('company_name')?.hasError('required')">Campo obrigatorio.</mat-error>
                </mat-form-field>
              </div>
              <div class="col-xs-12 col-sm-6">
                <mat-form-field appearance="outline" class="form-field">
                  <mat-label>Razao social</mat-label>
                  <input matInput formControlName="trading_name" />
                  <mat-error *ngIf="bankDetailsForm.get('trading_name')?.hasError('required')">Campo obrigatorio.</mat-error>
                </mat-form-field>
              </div>
              <div class="col-xs-12 col-sm-4">
                <mat-form-field appearance="outline" class="form-field">
                  <mat-label>Faturamento anual</mat-label>
                  <input matInput formControlName="annual_revenue" />
                  <mat-error *ngIf="bankDetailsForm.get('annual_revenue')?.hasError('required')">Campo obrigatorio.</mat-error>
                </mat-form-field>
              </div>
              <div class="col-xs-12 col-sm-4">
                <mat-form-field appearance="outline" class="form-field">
                  <mat-label>Tipo da empresa</mat-label>
                  <input matInput formControlName="corporation_type" placeholder="LTDA" />
                  <mat-error *ngIf="bankDetailsForm.get('corporation_type')?.hasError('required')">Campo obrigatorio.</mat-error>
                </mat-form-field>
              </div>
              <div class="col-xs-12 col-sm-4">
                <mat-form-field appearance="outline" class="form-field">
                  <mat-label>Data de fundacao</mat-label>
                  <input matInput type="date" formControlName="founding_date" />
                  <mat-error *ngIf="bankDetailsForm.get('founding_date')?.hasError('required')">Campo obrigatorio.</mat-error>
                </mat-form-field>
              </div>
              <div class="col-xs-12 col-sm-4">
                <mat-form-field appearance="outline" class="form-field">
                  <mat-label>Site</mat-label>
                  <input matInput formControlName="site_url" placeholder="https://empresa.com.br" />
                  <mat-error *ngIf="bankDetailsForm.get('site_url')?.hasError('required')">Campo obrigatorio.</mat-error>
                </mat-form-field>
              </div>
              <div class="col-xs-12 col-sm-2">
                <mat-form-field appearance="outline" class="form-field">
                  <mat-label>DDD</mat-label>
                  <input matInput formControlName="company_phone_ddd" maxlength="2" />
                  <mat-error *ngIf="bankDetailsForm.get('company_phone_ddd')?.invalid">Informe 2 digitos.</mat-error>
                </mat-form-field>
              </div>
              <div class="col-xs-12 col-sm-2">
                <mat-form-field appearance="outline" class="form-field">
                  <mat-label>Telefone</mat-label>
                  <input matInput formControlName="company_phone_number" maxlength="11" />
                  <mat-error *ngIf="bankDetailsForm.get('company_phone_number')?.invalid">Informe de 8 a 11 digitos.</mat-error>
                </mat-form-field>
              </div>
              <div class="col-xs-12"><h3>Endereco da Empresa</h3></div>
              <div class="col-xs-12 col-sm-5">
                <mat-form-field appearance="outline" class="form-field">
                  <mat-label>Rua</mat-label>
                  <input matInput formControlName="company_street" />
                  <mat-error *ngIf="bankDetailsForm.get('company_street')?.hasError('required')">Campo obrigatorio.</mat-error>
                </mat-form-field>
              </div>
              <div class="col-xs-12 col-sm-2">
                <mat-form-field appearance="outline" class="form-field">
                  <mat-label>Numero</mat-label>
                  <input matInput formControlName="company_street_number" />
                  <mat-error *ngIf="bankDetailsForm.get('company_street_number')?.hasError('required')">Campo obrigatorio.</mat-error>
                </mat-form-field>
              </div>
              <div class="col-xs-12 col-sm-5">
                <mat-form-field appearance="outline" class="form-field">
                  <mat-label>Complemento</mat-label>
                  <input matInput formControlName="company_complementary" />
                  <mat-error *ngIf="bankDetailsForm.get('company_complementary')?.hasError('required')">Campo obrigatorio.</mat-error>
                </mat-form-field>
              </div>
              <div class="col-xs-12 col-sm-5">
                <mat-form-field appearance="outline" class="form-field">
                  <mat-label>Bairro</mat-label>
                  <input matInput formControlName="company_neighborhood" />
                  <mat-error *ngIf="bankDetailsForm.get('company_neighborhood')?.hasError('required')">Campo obrigatorio.</mat-error>
                </mat-form-field>
              </div>
              <div class="col-xs-12 col-sm-5">
                <mat-form-field appearance="outline" class="form-field">
                  <mat-label>Cidade</mat-label>
                  <input matInput formControlName="company_city" />
                  <mat-error *ngIf="bankDetailsForm.get('company_city')?.hasError('required')">Campo obrigatorio.</mat-error>
                </mat-form-field>
              </div>
              <div class="col-xs-12 col-sm-2">
                <mat-form-field appearance="outline" class="form-field">
                  <mat-label>UF</mat-label>
                  <input matInput formControlName="company_state" maxlength="2" />
                  <mat-error *ngIf="bankDetailsForm.get('company_state')?.invalid">Informe a UF.</mat-error>
                </mat-form-field>
              </div>
              <div class="col-xs-12 col-sm-5">
                <mat-form-field appearance="outline" class="form-field">
                  <mat-label>CEP</mat-label>
                  <input matInput formControlName="company_zipcode" mask="00000-000" />
                  <mat-error *ngIf="bankDetailsForm.get('company_zipcode')?.invalid">Informe 8 digitos.</mat-error>
                </mat-form-field>
              </div>
              <div class="col-xs-12 col-sm-7">
                <mat-form-field appearance="outline" class="form-field">
                  <mat-label>Ponto de referencia</mat-label>
                  <input matInput formControlName="company_reference_point" />
                  <mat-error *ngIf="bankDetailsForm.get('company_reference_point')?.hasError('required')">Campo obrigatorio.</mat-error>
                </mat-form-field>
              </div>
              <div class="col-xs-12"><h3>Representante Legal</h3></div>
              <div class="col-xs-12 col-sm-6">
                <mat-form-field appearance="outline" class="form-field">
                  <mat-label>Nome</mat-label>
                  <input matInput formControlName="partner_name" />
                  <mat-error *ngIf="bankDetailsForm.get('partner_name')?.hasError('required')">Campo obrigatorio.</mat-error>
                </mat-form-field>
              </div>
              <div class="col-xs-12 col-sm-6">
                <mat-form-field appearance="outline" class="form-field">
                  <mat-label>CPF</mat-label>
                  <input matInput formControlName="partner_document_number" mask="000.000.000-00" />
                  <mat-error *ngIf="bankDetailsForm.get('partner_document_number')?.hasError('required')">Campo obrigatorio.</mat-error>
                  <mat-error *ngIf="bankDetailsForm.get('partner_document_number')?.hasError('cpfInvalid')">CPF invalido.</mat-error>
                </mat-form-field>
              </div>
              <div class="col-xs-12 col-sm-4">
                <mat-form-field appearance="outline" class="form-field">
                  <mat-label>Data de nascimento</mat-label>
                  <input matInput formControlName="partner_birthdate" type="date" />
                  <mat-error *ngIf="bankDetailsForm.get('partner_birthdate')?.hasError('required')">Campo obrigatorio.</mat-error>
                </mat-form-field>
              </div>
              <div class="col-xs-12 col-sm-4">
                <mat-form-field appearance="outline" class="form-field">
                  <mat-label>Email</mat-label>
                  <input matInput formControlName="partner_email" type="email" />
                  <mat-error *ngIf="bankDetailsForm.get('partner_email')?.hasError('required')">Campo obrigatorio.</mat-error>
                </mat-form-field>
              </div>
              <div class="col-xs-12 col-sm-4">
                <mat-form-field appearance="outline" class="form-field">
                  <mat-label>Renda mensal</mat-label>
                  <input matInput formControlName="partner_monthly_income" />
                  <mat-error *ngIf="bankDetailsForm.get('partner_monthly_income')?.hasError('required')">Campo obrigatorio.</mat-error>
                </mat-form-field>
              </div>
              <div class="col-xs-12 col-sm-6">
                <mat-form-field appearance="outline" class="form-field">
                  <mat-label>Ocupacao profissional</mat-label>
                  <input matInput formControlName="partner_professional_occupation" />
                  <mat-error *ngIf="bankDetailsForm.get('partner_professional_occupation')?.hasError('required')">Campo obrigatorio.</mat-error>
                </mat-form-field>
              </div>
              <div class="col-xs-12 col-sm-6">
                <mat-form-field appearance="outline" class="form-field">
                  <mat-label>Nome da mae</mat-label>
                  <input matInput formControlName="partner_mother_name" />
                </mat-form-field>
              </div>
              <div class="col-xs-12"><h3>Endereco do Representante</h3></div>
              <div class="col-xs-12 col-sm-5">
                <mat-form-field appearance="outline" class="form-field">
                  <mat-label>Rua</mat-label>
                  <input matInput formControlName="partner_street" />
                  <mat-error *ngIf="bankDetailsForm.get('partner_street')?.hasError('required')">Campo obrigatorio.</mat-error>
                </mat-form-field>
              </div>
              <div class="col-xs-12 col-sm-2">
                <mat-form-field appearance="outline" class="form-field">
                  <mat-label>Numero</mat-label>
                  <input matInput formControlName="partner_street_number" />
                  <mat-error *ngIf="bankDetailsForm.get('partner_street_number')?.hasError('required')">Campo obrigatorio.</mat-error>
                </mat-form-field>
              </div>
              <div class="col-xs-12 col-sm-5">
                <mat-form-field appearance="outline" class="form-field">
                  <mat-label>Complemento</mat-label>
                  <input matInput formControlName="partner_complementary" />
                  <mat-error *ngIf="bankDetailsForm.get('partner_complementary')?.hasError('required')">Campo obrigatorio.</mat-error>
                </mat-form-field>
              </div>
              <div class="col-xs-12 col-sm-5">
                <mat-form-field appearance="outline" class="form-field">
                  <mat-label>Bairro</mat-label>
                  <input matInput formControlName="partner_neighborhood" />
                  <mat-error *ngIf="bankDetailsForm.get('partner_neighborhood')?.hasError('required')">Campo obrigatorio.</mat-error>
                </mat-form-field>
              </div>
              <div class="col-xs-12 col-sm-5">
                <mat-form-field appearance="outline" class="form-field">
                  <mat-label>Cidade</mat-label>
                  <input matInput formControlName="partner_city" />
                  <mat-error *ngIf="bankDetailsForm.get('partner_city')?.hasError('required')">Campo obrigatorio.</mat-error>
                </mat-form-field>
              </div>
              <div class="col-xs-12 col-sm-2">
                <mat-form-field appearance="outline" class="form-field">
                  <mat-label>UF</mat-label>
                  <input matInput formControlName="partner_state" maxlength="2" />
                  <mat-error *ngIf="bankDetailsForm.get('partner_state')?.invalid">Informe a UF.</mat-error>
                </mat-form-field>
              </div>
              <div class="col-xs-12 col-sm-5">
                <mat-form-field appearance="outline" class="form-field">
                  <mat-label>CEP</mat-label>
                  <input matInput formControlName="partner_zipcode" mask="00000-000" />
                  <mat-error *ngIf="bankDetailsForm.get('partner_zipcode')?.invalid">Informe 8 digitos.</mat-error>
                </mat-form-field>
              </div>
              <div class="col-xs-12 col-sm-7">
                <mat-form-field appearance="outline" class="form-field">
                  <mat-label>Ponto de referencia</mat-label>
                  <input matInput formControlName="partner_reference_point" />
                  <mat-error *ngIf="bankDetailsForm.get('partner_reference_point')?.hasError('required')">Campo obrigatorio.</mat-error>
                </mat-form-field>
              </div>
              <div class="col-xs-12 col-sm-2">
                <mat-form-field appearance="outline" class="form-field">
                  <mat-label>DDD</mat-label>
                  <input matInput formControlName="partner_phone_ddd" maxlength="2" />
                  <mat-error *ngIf="bankDetailsForm.get('partner_phone_ddd')?.invalid">Informe 2 digitos.</mat-error>
                </mat-form-field>
              </div>
              <div class="col-xs-12 col-sm-4">
                <mat-form-field appearance="outline" class="form-field">
                  <mat-label>Telefone</mat-label>
                  <input matInput formControlName="partner_phone_number" maxlength="11" />
                  <mat-error *ngIf="bankDetailsForm.get('partner_phone_number')?.invalid">Informe de 8 a 11 digitos.</mat-error>
                </mat-form-field>
              </div>
            </ng-container>

            <div class="col-xs-12 col-sm-4">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Agencia</mat-label>
                <input matInput formControlName="branch_number" placeholder="Ex: 1234" maxlength="5" />
                <mat-error *ngIf="bankDetailsForm.get('branch_number')?.hasError('required')">O número da agencia é obrigatório.</mat-error>
                <mat-error *ngIf="bankDetailsForm.get('branch_number')?.hasError('pattern')">Informe apenas números, de 1 a 5 dígitos.</mat-error>
              </mat-form-field>
            </div>

            <div class="col-xs-12 col-sm-2">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Dígito agencia</mat-label>
                <input matInput formControlName="branch_check_digit" maxlength="1" placeholder="Ex: 0" (blur)="onBranchCheckDigitBlur()" />
                <mat-error *ngIf="bankDetailsForm.get('branch_check_digit')?.hasError('pattern')">Informe um inteiro maior ou igual a 0.</mat-error>
              </mat-form-field>
            </div>

            <div class="col-xs-12 col-sm-4">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Número da Conta</mat-label>
                <input matInput formControlName="account_number" maxlength="13" placeholder="Ex: 123456" />
                <mat-error *ngIf="accountNumber?.hasError('required')">O número da conta é obrigatório.</mat-error>
                <mat-error *ngIf="accountNumber?.hasError('pattern')">Informe apenas números, de 4 a 13 dígitos.</mat-error>
              </mat-form-field>
            </div>

            <div class="col-xs-12 col-sm-2">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Dígito conta</mat-label>
                <input matInput formControlName="account_check_digit" maxlength="1" placeholder="Ex: 7" />
                <mat-error *ngIf="accountDigit?.hasError('required')">O dígito da conta é obrigatório.</mat-error>
                <mat-error *ngIf="accountDigit?.hasError('pattern')">Informe 1 digito ou X.</mat-error>
              </mat-form-field>
            </div>

            <div class="col-xs-12 col-sm-6">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Tipo de Conta</mat-label>
                <mat-select formControlName="type">
                  <mat-option value="checking">Conta Corrente</mat-option>
                  <mat-option value="savings">Conta Poupanca</mat-option>
                </mat-select>
                <mat-error *ngIf="bankDetailsForm.get('type')?.hasError('required')">O tipo de conta é obrigatório.</mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-12">
              <h3>Configurações de Transferências</h3>
            </div>

            <div class="col-xs-12 col-sm-6">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Intervalo de Recebimento</mat-label>
                <mat-select formControlName="transfer_interval">
                  <mat-option value="daily">Diario</mat-option>
                  <mat-option value="weekly">Semanal</mat-option>
                  <mat-option value="monthly">Mensal</mat-option>
                </mat-select>
                <mat-error *ngIf="bankDetailsForm.get('transfer_interval')?.hasError('required')"
                  >O intervalo de recebimento é obrigatório.</mat-error
                >
              </mat-form-field>
            </div>

            <div class="col-xs-12 col-sm-6" *ngIf="showTransferDay">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>{{ transferDayLabel }}</mat-label>
                <mat-select formControlName="transfer_day">
                  <mat-option *ngFor="let day of transferDays" [value]="day">{{ transferDayOptionPrefix }} {{ day }}</mat-option>
                </mat-select>
                <mat-error *ngIf="bankDetailsForm.get('transfer_day')?.hasError('required')">O dia de recebimento é obrigatório.</mat-error>
                <mat-error *ngIf="bankDetailsForm.get('transfer_day')?.hasError('min') || bankDetailsForm.get('transfer_day')?.hasError('max')">
                  {{ transferDayErrorMessage }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </form>
      </mat-card>

      <div class="actions" align="end">
        <button mat-stroked-button color="primary" type="button" (click)="openOrCreateOnboarding()" [disabled]="loading || !canOpenOnboarding">
          {{ onboardingButtonLabel }}
        </button>
        <button mat-raised-button color="primary" type="button" (click)="createOrUpdateSettings()" [disabled]="loading || bankDetailsForm.invalid">
          <ng-container *ngIf="!loading">Salvar</ng-container>
          <ng-container *ngIf="loading">
            <mat-progress-spinner mode="indeterminate" diameter="20" strokeWidth="3"></mat-progress-spinner>
          </ng-container>
        </button>
      </div>
    </mat-tab>

    <mat-tab label="Formas de Pagamento">
      <mat-card>
        <form [formGroup]="paymentMethodsForm">
          <div class="row">
            <div class="col-xs-12">
              <h3>Formas de Pagamento</h3>
            </div>

            <div class="col-xs-12 col-sm-4">
              <mat-checkbox formControlName="PIXActive">PIX</mat-checkbox>
            </div>

            <div class="col-xs-12 col-sm-4">
              <mat-checkbox formControlName="CreditCardActive">Cartao de Credito</mat-checkbox>
            </div>

            <div class="col-xs-12 col-sm-4">
              <mat-checkbox formControlName="PhysicalActive">Presencial</mat-checkbox>
            </div>
          </div>

          <div class="actions" align="end">
            <button mat-raised-button color="primary" type="button" (click)="savePaymentMethods()" [disabled]="loading || paymentMethodsInvalid">
              Salvar
            </button>
          </div>
        </form>
      </mat-card>
    </mat-tab>

    <mat-tab label="Comissoes">
      <mat-card>
        <form [formGroup]="commissionForm">
          <div class="row">
            <div class="col-xs-12 col-sm-3">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Percentual da Organizacao (%)</mat-label>
                <input matInput formControlName="organization_percentage" type="number" />
              </mat-form-field>
              <p class="organization-percentage-display">Taxa operacional da plataforma: 10%</p>
            </div>

            <div class="col-xs-12">
              <p class="commission-validation-message">
                A organizacao fica com 90% do valor bruto. Os 10% restantes sao taxas operacionais da plataforma.
              </p>
            </div>
          </div>
        </form>
      </mat-card>
    </mat-tab></mat-tab-group
  >
</div>
